import { defineMessages } from 'react-intl';

const messages = defineMessages({
    acceptCookiePolicy: {
        id:'acceptCookiePolicy',
        defaultMessage: 'Accept',
        description: 'Button text to accept cookie policy',
    },
    cookieAcceptanceTitle: {
        id: 'cookieAcceptanceTitle',
        defaultMessage: 'We use cookies',
        description: 'Title text for accept cookies modal'
    }
});

export default messages;
